import { Checkbox } from "@/components/ui/checkbox";
import type { Question } from "./types";

interface GridRendererProps {
  question: Question;
  answer: any;
  onGridChoice: (row: string, col: string, multi: boolean) => void;
  lang?: "en" | "sw";
}

export const GridRenderer = ({ question: q, answer, onGridChoice, lang = "en" }: GridRendererProps) => {
  const grid = typeof q.options === "object" && !Array.isArray(q.options)
    ? q.options
    : { rows: [], columns: [] };

  const gridSw = lang === "sw" && q.options_sw && typeof q.options_sw === "object" && !Array.isArray(q.options_sw)
    ? q.options_sw
    : null;

  const rows: string[] = grid.rows || [];
  const columns: string[] = grid.columns || [];
  const displayRows: string[] = gridSw?.rows?.length === rows.length ? gridSw.rows : rows;
  const displayCols: string[] = gridSw?.columns?.length === columns.length ? gridSw.columns : columns;

  const isCheckbox = q.question_type === "checkbox_grid";

  return (
    <div className="overflow-x-auto">
      <table className="text-sm w-full">
        <thead>
          <tr>
            <th className="text-left p-1"></th>
            {displayCols.map((col: string, ci: number) => (
              <th key={columns[ci]} className="text-center p-1 font-medium">{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row: string, ri: number) => (
            <tr key={row} className="border-t">
              <td className="p-1 font-medium">{displayRows[ri]}</td>
              {columns.map((col: string) => (
                <td key={col} className="text-center p-1">
                  {isCheckbox ? (
                    <Checkbox
                      checked={((answer as Record<string, string[]>)?.[row] || []).includes(col)}
                      onCheckedChange={() => onGridChoice(row, col, true)}
                    />
                  ) : (
                    <input
                      type="radio"
                      name={`${q.id}_${row}`}
                      checked={(answer as Record<string, string>)?.[row] === col}
                      onChange={() => onGridChoice(row, col, false)}
                      className="accent-primary"
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
